import { memo, useMemo } from 'react';

import { BacktesterPnlReportRow } from '../../../../../providers/backtesting/api/backtester-config-api.types';

import { buildLineSeriesData, getRowFieldNumber } from './helpers';
import { MarketDataChart } from './market-data-chart';

interface ATMVolsChartProps {
  reports: BacktesterPnlReportRow[];
}

const VOL_SERIES = [
  { key: 'vol_1W', label: '1W' },
  { key: 'vol_2W', label: '2W' },
  { key: 'vol_1M', label: '1M' },
  { key: 'vol_2M', label: '2M' },
  { key: 'vol_3M', label: '3M' },
] as const;

export const ATMVolsChart = memo(({ reports }: ATMVolsChartProps) => {
  const seriesConfigs = useMemo(
    () =>
      VOL_SERIES.map(({ key, label }) => ({
        key,
        label,
        // Vols come off the backtester as raw decimals (0.70 == 70%). Scale to
        // percentage points here so the plotted line, axis and tooltip all read
        // as e.g. 70.00% (via valueSuffix below) rather than 0.70.
        data: buildLineSeriesData(reports, (row) => {
          const vol = getRowFieldNumber(row, key);
          return vol === null ? null : vol * 100;
        }),
      })),
    [reports],
  );

  return (
    <MarketDataChart
      cardKey="market-data-atm-vols-chart"
      title="ATM Vols"
      seriesConfigs={seriesConfigs}
      maximumFractionDigits={2}
      minMove={0.01}
      valueSuffix="%"
    />
  );
});

ATMVolsChart.displayName = 'ATMVolsChart';
